import React, { Component } from 'react';
import { Row, Col, Table } from "react-bootstrap";
import { CustomCard } from "../../../components/Card/CustomCard";

import EstSolvenciaTable from "./EstSolvenciaTable";

import { BusquedaEstInd, ConsultAutoridad } from "../../../funciones/CobranzasFunction";

class Solvencia extends Component {
    state = {
        string: "",
        icon2: "",
        listEst: [],
        preloaderI:{
            icon: "",
            text: "Ingresa la Cédula, el nombre o el apellido del estudiante para buscar"
        },
        autoridad: ""
    }

    componentDidMount = () => {
        ConsultAutoridad ((resp) => {
            this.setState({
                autoridad: resp
            })
        })
    }

    cambiaValor = (prop) => (e) => {
        this.setState({
            [prop]: e.target.value
        })
    }

    busquedaEst = () => (e) => {
        if (e.which === 13){
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                preloaderI:{
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando estudiantes, espera"
                },
            }, () => {
                BusquedaEstInd (this.state.string, (resp) => {
                    let prel = { icon: "", text: "" };
                    if (resp.length === 0) prel = { icon: "", text: "No existen coincidencias con la búsqueda seleccionada" };

                    this.setState({
                        listEst: resp,
                        icon2: "",
                        preloaderI: prel,
                    })

                })
            })
        }
    }

    contenido = () => {
        let { string, icon2, listEst, preloaderI, autoridad } = this.state;
        
        const styles = {
            padding: 5, fontSize: 12
        }

        let tablaEst = () => {
            if (listEst.length === 0) return (<div align="center" className="text-danger"><i className={preloaderI.icon}></i> {preloaderI.text}</div>)

            return (
                <div className="table-responsive" style={{overflowY: "auto", maxHeight: "50vh"}}>
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="45%" style={styles}><strong>Estudiante</strong></td>
                                <td width="35%" align="center" style={styles}><strong>Carrera</strong></td>
                                <td width="20%" align="center" style={styles}><strong>Estado</strong></td>
                                <td width="200px" align="center" style={styles}><strong>Acciones</strong></td>
                            </tr>
                            {listEst.map (option => (
                                <EstSolvenciaTable key={option.id} datos={option} autoridad ={autoridad}/>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )
        }

        return (
            <React.Fragment>
                <div className="custom-alert-info">
                    Búsqueda de Estudiantes <i className={icon2}></i>
                    <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={string} onChange={this.cambiaValor("string")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                </div>
                <div className="custom-mt-10">{tablaEst()}</div>
            </React.Fragment>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    En esta seccion puedes realizar un <strong className="text-primary">Reporte de Solvencia Administrativa</strong> al (a los) estudiante(s) seleccionados siempre y cuando no posean deudas.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Para ello primero debes ingresar un dato del estudiante que deseas consultar (Cédula, Nombre o Apellido)
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Al realizar la consulta podrás ver un listado con las coincidencias.
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    Al lado derecho de cada estudiante se encuentra el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>. Con las siguientes opciones:
                </Col>

                <Col md={4} align="justify" className="custom-mt-10 text-danger">
                    <div style={{fontSize: 10}}><i className="fa fa-money"></i> Estado de Cuenta</div>
                </Col>
                <Col md={8} align="justify" className="custom-mt-10">
                    Esta opción te permite ver todo el estado de cuenta del estudiante sin importar que posea deudas
                </Col>
                <Col md={4} align="justify" className="custom-mt-10 text-success">
                    <div style={{fontSize: 10}}><i className="fa fa-file"></i> Generar Solvencia</div>
                </Col>
                <Col md={8} align="justify" className="custom-mt-10">
                    Esta opción te permite generar una solvencia al estudiantes (solo los estudiantes sin deudas tienen esta opción disponible)
                </Col>
            </Row>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Solvencia Administrativa</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Solvencia;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/Solvencia.jsx